export enum SsbEntryPoint {
  INCLUSION = 'inclusion',
  EXCEPT = 'except',
  BOX_WIDE = 'box-wide',
}
